const TEST_RESULT_MESSAGES = {
  READY: "Ready.",
  ERROR: "Unable to connect to servers. Check your connection and retry."
};

export { TEST_RESULT_MESSAGES };
